import { getPartnerLogo } from '../../service/logo.service';
import { convertToBrazilianDate } from '../../service/date.service';
import { Box, Tooltip, Typography, useTheme } from '@mui/material';

const TEXT_MAX_LENGTH = 70;

const BasicInsuranceOffer = ({
  insurance,
  boardingDate,
  arrivalDate,
  destination,
}) => {
  const {
    insuranceCompany,
    insuranceName,
    coverageUrl,
    insuranceUrl,
    ageInfo,
  } = insurance;

  const isAgeInfoTextTooLong = ageInfo.length > TEXT_MAX_LENGTH;
  const ageInfoTooltipText = isAgeInfoTextTooLong ? ageInfo : null;
  const ageInfoText = isAgeInfoTextTooLong
    ? ageInfo.slice(0, TEXT_MAX_LENGTH).trim() + '...'
    : ageInfo;

  const theme = useTheme();

  return (
    <Box
      sx={{
        width: '100%',
        backgroundColor: `${theme.palette.primary.dark}`,
        color: `${theme.palette.primary.contrastText}`,
        borderRadius: `${theme.spacingValues.medium}`,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        padding: `${theme.spacingValues.mediumLarge}`,
        gap: `${theme.spacingValues.medium}`,
      }}
    >
      <Typography variant="h3">{destination}</Typography>
      <Typography variant="body2" sx={{ color: `${theme.palette.grey[100]}` }}>
        {convertToBrazilianDate(boardingDate)} -{' '}
        {convertToBrazilianDate(arrivalDate)}
      </Typography>
      <Box
        sx={{
          width: '100%',
          maxWidth: '200px',
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          '& svg': { height: '100%', width: '100%' },
          color: 'white',
        }}
      >
        {getPartnerLogo(insuranceCompany).component.dark}
      </Box>
      <Typography variant="h3">{insuranceName}</Typography>
      <Tooltip title={ageInfoTooltipText}>
        <Typography variant="body1">{ageInfoText}</Typography>
      </Tooltip>
      {coverageUrl && (
        <a
          className="full-subscription-info link"
          href={coverageUrl}
          target="_blank"
          rel="noreferrer"
          style={{
            textDecoration: 'underline',
            textDecorationColor: `${theme.palette.grey[100]}`,
          }}
        >
          {' '}
          <Typography
            variant="body2"
            sx={{ color: `${theme.palette.primary.contrastText}` }}
          >
            Ver cobertura completa
          </Typography>
        </a>
      )}
      {insuranceUrl && (
        <a
          className="full-subscription-info link"
          href={insuranceUrl}
          target="_blank"
          rel="noreferrer"
        >
          <Typography
            variant="body2"
            sx={{ color: `${theme.palette.primary.contrastText}` }}
          >
            informações e regras do plano
          </Typography>
        </a>
      )}
    </Box>
  );
};

export default BasicInsuranceOffer;
